import { NodeViewContent, NodeViewWrapper } from "@knowt/editor/react";
import Select from "@/components/Select";
import { themeColors } from "@/utils/themeColors";
import { ChevronDown } from "lucide-react";
import { iconSizes } from "@/utils/iconProps";

const SUPPORTED_PROGRAMMING_LANG = [
    { value: "bash", label: "Bash" },
    { value: "c", label: "C" },
    { value: "cpp", label: "C++" },
    { value: "csharp", label: "C#" },
    { value: "css", label: "CSS" },
    { value: "go", label: "Go" },
    { value: "graphql", label: "GraphQL" },
    { value: "java", label: "Java" },
    { value: "javascript", label: "JavaScript" },
    { value: "json", label: "JSON" },
    { value: "kotlin", label: "Kotlin" },
    { value: "markdown", label: "Markdown" },
    { value: "objectivec", label: "Objective-C" },
    { value: "php", label: "PHP" },
    { value: "python", label: "Python" },
    { value: "r", label: "R" },
    { value: "ruby", label: "Ruby" },
    { value: "rust", label: "Rust" },
    { value: "scss", label: "SCSS" },
    { value: "shell", label: "Shell" },
    { value: "sql", label: "SQL" },
    { value: "swift", label: "Swift" },
    { value: "typescript", label: "TypeScript" },
    { value: "xml", label: "XML" },
    { value: "yaml", label: "YAML" },
];

const CodeBlockComponent = ({ node, updateAttributes, extension, editor }) => {
    const defaultLanguage = node.attrs.language;
    const defaultOptions = [{ label: "auto", value: null }];

    const supportedLangNames = SUPPORTED_PROGRAMMING_LANG.map(lang => lang.value);

    const langOptions = extension.options.lowlight
        .listLanguages()
        .filter((value: string) => {
            return supportedLangNames.includes(value);
        })
        .map((value: string) => {
            const language = SUPPORTED_PROGRAMMING_LANG.find(l => l.value === value);
            return { label: language?.label || value, value: value };
        });

    const options = [...defaultOptions, ...langOptions];

    return (
        <NodeViewWrapper style={{ position: "relative" }}>
            <Select
                disabled={!editor.isEditable}
                options={options}
                btnSx={{
                    position: "absolute",
                    right: "0.5rem",
                    top: "0.5rem",
                    backgroundColor: themeColors.neutralWhite,
                    borderRadius: "2rem",
                    fontSize: "1.2rem",
                    height: "3rem",
                    userSelect: "none",
                }}
                menuSx={{ width: "fit-content", maxHeight: "32rem", "& > ul": { paddingLeft: 0 } }}
                transitionOrigin={{
                    anchorOrigin: { vertical: "center", horizontal: "center" },
                    transformOrigin: { vertical: "center", horizontal: "center" },
                }}
                selected={{ label: defaultLanguage, value: defaultLanguage }}
                onChange={({ label: lang }) => updateAttributes({ language: lang })}
                adornment={
                    editor.isEditable ? <ChevronDown size={iconSizes.SM} fill={"currentColor"} strokeWidth={0} /> : null
                }
                renderLabel={({ label }) => label || "auto"}
                data-testid="auto-id-6647f4a8-0615-4184-a02f-ae3485b9b9bf" />
            <pre data-testid="auto-id-6799369d-8d02-41f2-929f-dfe0c2587cbd">
                <NodeViewContent as="code" />
            </pre>
        </NodeViewWrapper>
    );
};

export default CodeBlockComponent;
